import React from 'react';

interface ChevronIconProps {
    className?: string;
    style?: React.CSSProperties;
}

export const ChevronUpIcon: React.FC<ChevronIconProps> = ({ className, style }) => {
    return (
        <svg
            className={className}
            style={style}
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 64 64"
            width="64px"
            height="64px"
        >
            <path d="M31.996 30.906L58.996 46.626 58.996 36.626 32 15 4.996 36.626 4.996 46.626z" />
        </svg>
    );
};

export const ChevronDownIcon: React.FC<ChevronIconProps> = ({ className, style }) => {
    return (
        <svg
            className={className}
            style={style}
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 64 64"
            width="64px"
            height="64px"
        >
            <path d="M31.996 33.094L58.996 17.374 58.996 27.374 32 49 4.996 27.374 4.996 17.374z" />
        </svg>
    );
};
